<template>
    <v-card class="ma-2" raised>
        <v-card-title>
            {{task.title}}
            <v-spacer></v-spacer>
            <v-checkbox :label="checkBoxLabel" v-model="isCompleted" @click="check"/>
        </v-card-title>
        <v-card-text v-if="task.notes">
            {{task.notes}}
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        name: "Task",
        props: {
            task: Object
        },
        computed: {
            checkBoxLabel() {
                return this.task.isCompleted ? "Completed" : "Not Completed";
            }
        },
        methods: {
            ...mapMutations(["modifyTask"]),
            check() {
                this.isCompleted = !this.isCompleted;
                this.modifyTask(this.task)
            }
        },
        created() {
            this.isCompleted = this.task.isCompleted;
        },
        data: () => {
            return {
                isCompleted: false
            }
        }
    }
</script>

<style scoped>

</style>